module.exports = __webpack_public_path__ + "img/详细解决方案_03.7efde80d.svg";